(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tee-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const initialize = (root) => {
      if (!root || root.dataset.tabsReady === 'true') return;
      root.dataset.tabsReady = 'true';

      const configNode = root.querySelector('[data-customizer-config]');
      const configText = configNode?.textContent?.replace(/"id"\s*:\s*(\d+)/g, '"id":"$1"') || '{}';
      const configs = JSON.parse(configText);
      const tabs = [...root.querySelectorAll('[data-garment-tab]')];
      const stage = root.querySelector('[data-customizer-stage]');
      const workspace = root.querySelector('[role="tabpanel"]');
      const heading = root.querySelector('[data-customizer-heading]');
      const garmentPreview = root.querySelector('[data-garment-preview]');
      const garmentStyle = root.querySelector('[data-garment-style]');
      const sizeSelect = root.querySelector('[data-size-select]');
      const itemType = root.querySelector('[data-item-type]');
      const stepOneLabel = root.querySelector('[data-step-one-label]');
      const colourGroups = [...root.querySelectorAll('[data-colour-options]')];
      const fixedColour = root.querySelector('[data-fixed-colour]');
      const fixedColourName = root.querySelector('[data-fixed-colour-name]');
      const colourName = root.querySelector('[data-colour-name]');
      const colourProperty = root.querySelector('[data-colour-property]');
      const activePrice = root.querySelector('[data-active-price]');
      const artworkLayer = root.querySelector('[data-artwork-layer]');
      const artworkPreview = root.querySelector('[data-artwork-preview]');
      const placeholder = root.querySelector('[data-artwork-placeholder]');
      const artworkInput = root.querySelector('[data-artwork-input]');
      const error = root.querySelector('[data-artwork-error]');
      const scaleInput = root.querySelector('[data-artwork-scale]');
      const xInput = root.querySelector('[data-artwork-x]');
      const yInput = root.querySelector('[data-artwork-y]');
      const placement = root.querySelector('[data-placement]');
      const method = root.querySelector('[data-print-method]');
      const submit = root.querySelector('[data-customizer-submit]');
      const embroideryNote = root.querySelector('[data-embroidery-note]');
      const emailLink = root.querySelector('[data-email-summary]');
      let activeType = 'tshirt';
      let activeTab = tabs[0];
      let objectUrl = '';

      const replaceOptions = (select, values, placeholderText = '') => {
        if (!select) return;
        select.replaceChildren();
        if (placeholderText) {
          const placeholderOption = new Option(placeholderText, '');
          placeholderOption.disabled = true;
          placeholderOption.selected = true;
          select.add(placeholderOption);
        }
        values.forEach((value) => select.add(new Option(value, value)));
      };

      const formatPrice = (priceInCents) => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: root.dataset.currency || 'CAD'
      }).format(Number(priceInCents || 0) / 100);

      const hydrateVariantSelect = (type) => {
        const select = root.querySelector(`[data-product-variants="${type}"]`);
        const variants = configs[type]?.variants;
        if (!select || !Array.isArray(variants) || variants.length === 0) return;
        select.replaceChildren();
        variants.forEach((variant) => {
          const option = new Option(variant.title, String(variant.id));
          option.dataset.size = variant.option1 || '';
          option.dataset.colour = variant.option2 || '';
          option.dataset.price = formatPrice(variant.price);
          option.disabled = variant.available === false;
          select.add(option);
        });
      };

      const syncEmail = () => {
        if (!emailLink) return;
        const valueFor = (selector) => root.querySelector(selector)?.value || 'Not selected';
        const filename = artworkInput?.files?.[0]?.name || 'Not attached';
        const reference = root.querySelector('[data-customizer-reference]')?.value || '';
        const itemLabel = configs[activeType]?.label || 'Custom item';
        const body = [
          'Hello Aflatoon Tees,',
          '',
          `I would like help with this custom ${itemLabel.toLowerCase()}:`,
          `Reference: ${reference}`,
          `Item: ${itemLabel}`,
          `Garment: ${valueFor('[name="properties[Garment]"]')}`,
          `Colour: ${colourProperty?.value || 'Not selected'}`,
          `Size: ${valueFor('[name="properties[Size]"]')}`,
          `Quantity: ${valueFor('[name="quantity"]')}`,
          `Print method: ${valueFor('[name="properties[Print method]"]')}`,
          `Placement: ${valueFor('[name="properties[Placement]"]')}`,
          `Artwork file: ${filename}`,
          '',
          'I will attach the artwork file to this email.'
        ].join('\n');
        emailLink.href = `mailto:${root.dataset.supportEmail}?subject=${encodeURIComponent(`Custom ${itemLabel} enquiry ${reference}`)}&body=${encodeURIComponent(body)}`;
      };

      const syncArtwork = () => {
        if (!artworkLayer) return;
        const scale = Number(scaleInput?.value || 28);
        const x = Number(xInput?.value || 50);
        const y = Number(yInput?.value || 39);
        artworkLayer.style.width = `${scale}%`;
        artworkLayer.style.left = `${x}%`;
        artworkLayer.style.top = `${y}%`;
        root.querySelector('[data-scale-output]')?.replaceChildren(`${scale}%`);
        const scaleProperty = root.querySelector('[data-scale-property]');
        const xProperty = root.querySelector('[data-x-property]');
        const yProperty = root.querySelector('[data-y-property]');
        if (scaleProperty) scaleProperty.value = `${scale}%`;
        if (xProperty) xProperty.value = `${x}%`;
        if (yProperty) yProperty.value = `${y}%`;
        syncEmail();
      };

      const activeVariantSelect = () => root.querySelector(`[data-product-variants="${activeType}"]`);

      const productReady = () => {
        const select = activeVariantSelect();
        const option = select?.options?.[select.selectedIndex];
        return Boolean(sizeSelect?.value && option && !option.disabled && option.dataset.size === sizeSelect.value && option.dataset.colour === colourProperty?.value);
      };

      const syncMethod = () => {
        const isEmbroidery = method?.value === 'Embroidery quote';
        const connected = Boolean(activeVariantSelect());
        const ready = productReady();
        if (embroideryNote) embroideryNote.hidden = !isEmbroidery;
        if (submit) {
          submit.disabled = isEmbroidery || !ready;
          if (isEmbroidery) submit.textContent = 'Request an embroidery quote below';
          else if (!connected) submit.textContent = activeTab.dataset.setupLabel;
          else submit.textContent = ready ? activeTab.dataset.addLabel : 'Choose a size to continue';
        }
        syncEmail();
      };

      const syncVariant = () => {
        const select = activeVariantSelect();
        const size = sizeSelect?.value || '';
        const colour = colourProperty?.value || '';
        const option = select ? [...select.options].find((item) => !item.disabled && item.dataset.size === size && item.dataset.colour === colour) : null;

        if (select && option) select.value = option.value;
        if (activePrice) {
          const fallback = select?.options?.[0]?.dataset.price || '—';
          activePrice.textContent = option?.dataset.price || fallback;
        }
        syncMethod();
      };

      const activate = (tab, moveFocus = false) => {
        activeTab = tab;
        activeType = tab.dataset.garmentTab;
        const config = configs[activeType];
        if (!config) return;

        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        if (moveFocus) tab.focus();
        if (workspace) workspace.setAttribute('aria-labelledby', tab.id);
        if (heading) heading.textContent = tab.dataset.heading;
        if (stepOneLabel) stepOneLabel.textContent = config.stepLabel;
        if (itemType) itemType.value = config.label;
        if (garmentPreview) {
          garmentPreview.src = tab.dataset.previewSrc;
          garmentPreview.alt = tab.dataset.previewAlt;
          garmentPreview.dataset.previewFit = tab.dataset.previewFit;
        }

        replaceOptions(garmentStyle, config.styles);
        replaceOptions(sizeSelect, config.sizes, activeType === 'tote' ? '' : 'Choose a size');
        if (activeType === 'tote' && sizeSelect) sizeSelect.value = config.sizes[0];
        if (placement) {
          placement.replaceChildren();
          config.placements.forEach((item) => {
            const option = new Option(item.label, item.value);
            option.dataset.x = item.x;
            option.dataset.y = item.y;
            option.dataset.scale = item.scale;
            placement.add(option);
          });
        }

        const firstPlacement = config.placements[0];
        if (xInput) xInput.value = firstPlacement.x;
        if (yInput) yInput.value = firstPlacement.y;
        if (scaleInput) scaleInput.value = firstPlacement.scale;

        const hasColourChoices = activeType === 'tshirt' || activeType === 'hoodie';
        colourGroups.forEach((group) => {
          const selectedGroup = group.dataset.colourOptions === activeType;
          group.hidden = !selectedGroup;
          group.querySelectorAll('[data-colour]').forEach((button) => {
            const selected = selectedGroup && button.dataset.colour === tab.dataset.colour;
            button.classList.toggle('is-active', selected);
            button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        });
        if (fixedColour) fixedColour.hidden = hasColourChoices;
        if (fixedColourName) fixedColourName.textContent = tab.dataset.colour;
        if (colourName) colourName.textContent = tab.dataset.colour;
        if (colourProperty) colourProperty.value = tab.dataset.colour;

        root.querySelectorAll('[data-variant-group]').forEach((group) => {
          const selected = group.dataset.variantGroup === activeType;
          group.hidden = !selected;
          const select = group.querySelector('select');
          if (select) {
            select.disabled = !selected;
            if (selected) select.name = 'id';
            else select.removeAttribute('name');
          }
        });
        root.querySelectorAll('[data-setup-note]').forEach((note) => {
          const connected = Boolean(root.querySelector(`[data-product-variants="${note.dataset.setupNote}"]`));
          note.hidden = note.dataset.setupNote !== activeType || connected;
        });

        syncArtwork();
        syncVariant();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(tabs[nextIndex], true);
        });
      });

      root.querySelectorAll('[data-colour]').forEach((button) => {
        button.addEventListener('click', () => {
          const group = button.closest('[data-colour-options]');
          if (!group || group.dataset.colourOptions !== activeType) return;
          group.querySelectorAll('[data-colour]').forEach((item) => {
            const selected = item === button;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          if (garmentPreview && button.dataset.previewSrc) {
            garmentPreview.src = button.dataset.previewSrc;
            garmentPreview.alt = `${button.dataset.colour} ${activeType === 'hoodie' ? 'hoodie' : 'T-shirt'} preview`;
          }
          if (colourName) colourName.textContent = button.dataset.colour;
          if (colourProperty) colourProperty.value = button.dataset.colour;
          syncVariant();
        });
      });

      artworkInput?.addEventListener('change', () => {
        const file = artworkInput.files?.[0];
        if (!file || !artworkPreview) {
          syncEmail();
          return;
        }
        const maxBytes = Number(root.dataset.maxFileMb || 20) * 1024 * 1024;
        if (file.size > maxBytes) {
          artworkInput.value = '';
          if (error) error.textContent = `Please choose a file smaller than ${root.dataset.maxFileMb || 20} MB.`;
          syncEmail();
          return;
        }
        if (error) error.textContent = '';
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = URL.createObjectURL(file);
        artworkPreview.src = objectUrl;
        artworkPreview.hidden = false;
        if (placeholder) placeholder.hidden = true;
        artworkPreview.onerror = () => {
          artworkPreview.hidden = true;
          if (placeholder) placeholder.hidden = false;
          if (error) error.textContent = 'This file can be ordered, but this browser cannot preview it. PNG, JPG or WebP gives the best live preview.';
        };
        syncEmail();
      });

      placement?.addEventListener('change', () => {
        const option = placement.options[placement.selectedIndex];
        if (xInput) xInput.value = option.dataset.x || 50;
        if (yInput) yInput.value = option.dataset.y || 39;
        if (scaleInput) scaleInput.value = option.dataset.scale || 28;
        syncArtwork();
      });

      [scaleInput, xInput, yInput].forEach((input) => input?.addEventListener('input', syncArtwork));

      if (stage && artworkLayer) {
        artworkLayer.addEventListener('pointerdown', (event) => {
          if (!artworkPreview || artworkPreview.hidden) return;
          artworkLayer.setPointerCapture(event.pointerId);
          artworkLayer.classList.add('is-dragging');
        });
        artworkLayer.addEventListener('pointermove', (event) => {
          if (!artworkLayer.hasPointerCapture(event.pointerId)) return;
          const rect = stage.getBoundingClientRect();
          if (xInput) xInput.value = clamp(Math.round(((event.clientX - rect.left) / rect.width) * 100), 25, 75);
          if (yInput) yInput.value = clamp(Math.round(((event.clientY - rect.top) / rect.height) * 100), 22, 75);
          syncArtwork();
        });
        const finishDrag = (event) => {
          if (artworkLayer.hasPointerCapture(event.pointerId)) artworkLayer.releasePointerCapture(event.pointerId);
          artworkLayer.classList.remove('is-dragging');
        };
        artworkLayer.addEventListener('pointerup', finishDrag);
        artworkLayer.addEventListener('pointercancel', finishDrag);
      }

      method?.addEventListener('change', syncMethod);
      sizeSelect?.addEventListener('change', syncVariant);
      ['tshirt', 'hoodie', 'tote'].forEach(hydrateVariantSelect);
      root.querySelectorAll('[data-product-variants]').forEach((select) => select.addEventListener('change', syncEmail));
      root.querySelectorAll('[data-summary-field], textarea').forEach((field) => field.addEventListener('change', syncEmail));

      const reference = root.querySelector('[data-customizer-reference]');
      if (reference) reference.value = `AT-${Date.now().toString(36).toUpperCase()}`;
      activate(tabs[0]);
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('[data-customizer-tabs]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#hoodie-duo"]');
  const panel = document.getElementById('hoodie-duo');
  if (!link || !panel) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  panel.setAttribute('tabindex', '-1');
  panel.focus({ preventScroll: true });
  panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  history.replaceState(null, '', '#hoodie-duo');
}, true);

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('[data-hoodie-duo]')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const button = form.querySelector('button[type="submit"]');
  const error = form.querySelector('[data-duo-error]');
  const items = Array.from(form.querySelectorAll('[data-duo-variant]'), select => ({ id: Number(select.value), quantity: 1 }));
  button.disabled = true;
  form.setAttribute('aria-busy', 'true');
  error.hidden = true;
  try {
    const response = await fetch(form.action + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || form.dataset.error);
    window.location.assign(form.dataset.cartUrl);
  } catch (failure) {
    error.textContent = failure.message || form.dataset.error;
    error.hidden = false;
    button.disabled = false;
    form.removeAttribute('aria-busy');
  }
}, true);


  } catch(e) { console.error(e); }
})();
})();
